/**
 * Converts a string to snake_case format
 * convertToSnakeCase("Top Rated") // returns "top_rated"
 * convertToSnakeCase("Latest") // returns "latest"
 */
export const convertToSnakeCase = (str: string): string => {
  return str.toLowerCase().split(" ").join("_");
};
